let $api: { (message: string, params?: { [key: string]: any }): string };

$api = (service: string, params?: { [key: string]: any }): string => {
  const services: { [service: string]: any } = {
    selected_services: "selected-services",
    get_all_services: "services",
    get_service: "/getService/{service_id}",
    get_campaign: "/get-campaign",
    get_most_seller: "/most-sels-product",
    get_product_details: "/productDetail/{products_id}",
    get_phone_prefix: "/get-phone-prefix",
    get_all_blogs: "/blogs",
    get_blog_by_id: "/blogs/{blog_id}",
    post_login: "/login",
    post_logout: "/logout",
    get_all_videos: "/videos",
    get_adress: "/branches",
    get_vacancies: "/vacancy",
    get_vacancies_Detail: "/vacancy./{id}",
    create_vacancy: "/vacancy/{id}",
    show_product: "/mehsullar/{id}",
    get_all_partners: "/partners",
    basket: "/basket",
    remove_basket: "basket/{id}",
    total_basket: "basket/total",
    favorites: "/wishlist",
    remove_favorites: "/wishlist/{id}",
    get_offer_week: "/weekly-picks",
    last_view_products: "/mehsullar/reliated-products",
    get_profile_data: "/profile",
    show_campaign: "show-campaign/{id}",
    post_register: "/register",
    post_otp: "/verify-otp",
    get_forget_password: "/forget-password",
    edit_profile_info: "/edit-user-profile",
    get_header_categories: "/header-product-categories",
    post_contact: "/feedback",
    get_filials: "/branches",
    get_about: "/about",
    get_search_product: "/search",
    translations: "/translation",
    post_changepasword: "/changePassword",
    post_repair: "/apply-repair-service",
    filter_items_id: "/get-filter-items/{id}",
    filter_data: "/filter-data",
    post_order: "/accessory-order",
    get_order_category: "/order-category",
    get_order: "/orders",
    get_header_services: "/getHeaderService",
    get_order_services: "orders/service-order",
    create_order: "/orders",
    get_order_accessory: "/orders/accessory-order",
    cancel_order: "/orders/cancel-order/{id}",
    cancel_service_order: "/orders/cancel-service-order/{id}",
    cancel_accessory_order: "/orders/cancel-accessory-order/{id}",
    get_news: "/news",
    get_news_id: "/news-show/{slug}",
    get_officialServices: "/official-services",
    get_ServicesBrands: "/order-brands",
    social_accounts: "/social-accounts",
    post_assembling: "/apply-assembling-service",
    get_languages: "/language",
    pages: "/page/{id}",
    chatbot_template: "/chat-bot",
    chatbot_template_id: "/chat-bot/{id}",
    post_user_data: "/live-chat/start-chat",
    send_message: "/live-chat/{id}/message",
    subscribe: "/subscribe",
    post_quick_order: "/quick-order",
    popup: "/popup",
  };
  if (typeof services[service] === "string") {
    services[service] = { path: String(services[service]) };
  }

  let url = services[service].path;
  if (params) {
    let query_params: { [key: string]: any } = {};
    let has_query_params = false;

    for (const [key, value] of Object.entries(params)) {
      let replaced = false;
      url = url.replaceAll("{" + key + "}", () => {
        replaced = true;
        return value;
      });
      if (!replaced) {
        has_query_params = true;
        query_params[key] = value;
      }
    }

    if (has_query_params) {
      let param = new URLSearchParams(query_params);
      url += "?" + param.toString();
    }
  }
  return url;
};

export { $api };
